import { Link } from 'react-router-dom';
import { DismissButton } from '@/components/DismissButton';
import { useDismissed } from '@/components/useDismissed';

/**
 * Invitation to organisers, right half of the pair.
 *
 * <p>Submitting is already in the nav, so this exists to supply the half the nav can't: the
 * reason. "Add your event" answers <em>what</em> and never <em>why</em>, and the why — people
 * searching your area will find it — is the entire pitch to someone running events.
 *
 * <p>Unconditional, unlike the alerts card. There's no signal in the app for "this person runs
 * events", so the only way it goes away is being closed.
 */
export function OrganiserPrompt() {
  const [dismissed, dismiss] = useDismissed('organiser-prompt');

  if (dismissed) return null;

  return (
    <aside className="promo">
      <div className="promo__body">
        <p className="promo__title">Run events like this?</p>
        <p className="promo__text">Add yours so people can find it.</p>
      </div>

      <Link className="button button--primary" to="/submit">
        Add your event
      </Link>

      <DismissButton label="Dismiss the organiser prompt" onDismiss={dismiss} />
    </aside>
  );
}
